import { render, staticRenderFns } from "./AddProduct.vue?vue&type=template&id=0bd0ff78&scoped=true"
import script from "./AddProduct.vue?vue&type=script&lang=js"
export * from "./AddProduct.vue?vue&type=script&lang=js"
import style0 from "./AddProduct.vue?vue&type=style&index=0&id=0bd0ff78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd0ff78",
  null
  
)

export default component.exports